import { FC } from "react";
import { View, StyleSheet } from "@react-pdf/renderer";

import { ArchwayLogo } from "..";

type Props = {};

const styles = StyleSheet.create({
  footer: {
    marginTop: 12,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
});

export const Footer: FC<Props> = () => {
  return (
    <View style={styles.footer} wrap={false}>
      <ArchwayLogo />
    </View>
  );
};
